import { Point } from 'geojson';

export function pointToLatLng(point: Point): google.maps.LatLngLiteral {
  return { lat: point.coordinates[1], lng: point.coordinates[0] };
}

export function latLngToPoint({ lat, lng }: google.maps.LatLngLiteral): Point {
  return {
    type: 'Point',
    coordinates: [lng, lat]
  };
}
